// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"631b61c8","453":"3b302ca5","455":"908fdf55","977":"0d993d6e"}[chunkId] + ".chunk.js";
};